import { StyleSheet } from 'react-native'
import theme from '../../../../theme'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        paddingHorizontal: 0,
        paddingTop: 0,
        paddingBottom: 8,
    },
    subtitle: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        paddingHorizontal: 0,
        paddingTop: 5,
        paddingBottom: 8,
    },
    inputRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 44,
        borderRadius: 8,
        backgroundColor: theme.colors.inputBackground,
        paddingHorizontal: 12,
        marginBottom: 5,
    },
    inputRowDisabled: {
        backgroundColor: theme.colors.lightGray,
    },
    inputText: {
        fontSize: 15,
        color: theme.colors.textPrimary,
    },
    placeholderText: {
        color: theme.colors.inputPlaceholder,
    },
})

export default styles
